module.exports = __webpack_public_path__ + "img/ae.d5ca4f8e.svg";